import React from "react";

/**
 * כפתורים כמו .fw-btn בתוך אשף — עובד בתוך .fw-ui-page-shell (או .fw-root).
 */
export default function FWButton({
  variant = "default",
  children,
  className = "",
  type = "button",
  ...rest
}) {
  const base = "fw-btn";
  const v =
    variant === "primary"
      ? "fw-btn--primary"
      : variant === "ghost"
        ? "fw-btn--ghost"
        : "";
  return (
    <button
      type={type}
      className={`${base}${v ? ` ${v}` : ""}${className ? ` ${className}` : ""}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
}
